const beneficios = [
  {
    icon: 'ri-brush-line',
    title: 'Instalação limpa',
    description:
      'Sistema pensado para reduzir interferência na operação quando comparado a soluções tradicionais.',
  },
  {
    icon: 'ri-grid-line',
    title: 'Modularidade',
    description: 'Possibilidade de reorganização dos ambientes conforme o sistema especificado.',
  },
  {
    icon: 'ri-recycle-line',
    title: 'Reaproveitamento',
    description:
      'Determinados sistemas podem ser desmontados e reaproveitados em novas configurações.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Privacidade',
    description: 'Opções com diferentes níveis de privacidade visual.',
  },
  {
    icon: 'ri-volume-up-line',
    title: 'Acústica',
    description: 'Configurações adequadas para salas que precisam de maior conforto acústico.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Estética',
    description:
      'Perfis, painéis, vidros e acabamentos compatíveis com projetos corporativos contemporâneos.',
  },
];

export default function PorQueSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Por que divisória corporativa
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight">
            Ambientes que acompanham a evolução da empresa.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {beneficios.map((b) => (
            <div
              key={b.title}
              className="group rounded-2xl border border-background-200/60 bg-background-50 p-7 transition-colors hover:border-background-300"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-white border border-background-200/60 text-foreground-700 mb-5 group-hover:text-primary-500 group-hover:border-primary-200 transition-colors">
                <i className={`${b.icon} text-xl`}></i>
              </span>
              <h3 className="text-foreground-950 font-semibold text-[16px] mb-2">{b.title}</h3>
              <p className="text-foreground-500 text-[14px] leading-relaxed font-light">
                {b.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}